import React from 'react';

const Pay = () => {
    return (
        <div className="text-danger">
            Payment system coming soon
        </div>
    );
};

export default Pay;